import { render } from "./Comments.vue?vue&type=template&id=44841820&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=44841820&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44841820"

export default script